/* eslint-disable no-template-curly-in-string */
import React from 'react';
import { RemoteSelect } from '@unicus/react-ui-kit';
import { Form, Row, Col, Button } from 'antd';
import FormManager from 'components/FormManager';

const defaultValidateMessages = {
  required: '${label} é obrigatório'
};

const funcDefault = (c) => c;

const RemoteInsert = ({
  name,
  resource,
  label,
  onValidate,
  onChange = funcDefault
}) => {
  const [form] = Form.useForm();
  const formEditing = FormManager.useForm();

  const handleAdd = (value) => {
    const values = formEditing.getFieldValue(name) || [];

    if (onValidate) {
      const error = onValidate({ items: values, item: value });

      if (error) {
        form.setFields([{ name, errors: [error] }]);
        return;
      }
    }

    formEditing.setFieldsValue({
      [name]: [...values, value]
    });

    form.resetFields();
  };

  const handleClick = () => {
    form.validateFields().then((values) => {
      handleAdd(onChange(values[name]));
    });
  };

  return (
    <Form
      colon={false}
      labelCol={{ span: 5 }}
      form={form}
      validateMessages={defaultValidateMessages}
    >
      <Row>
        <Col span={19}>
          <Form.Item name={name} label={label} rules={[{ required: true }]}>
            <RemoteSelect resource={resource} />
          </Form.Item>
        </Col>
        <Col span={5} onClick={handleClick}>
          <Button type="primary">Adicionar</Button>
        </Col>
      </Row>
    </Form>
  );
};

export default RemoteInsert;
